<script lang="ts">
    import ProductGrid from '@tilelist/components/tile-list/ProductGrid.svelte';
    import TileListSheets from '@tilelist/components/tile-list/TileListSheets.svelte';
    import type { ProductItem, TileItem, TileListItem } from '@tilelist/domain/composition/TileListitem.ts';
    import type { TileListPageContext } from '@tilelist/domain/composition/TileListPage.ts';
    import type { FeatureIndexOffset } from '@tilelist/domain/external-data-attributes/ExternalDataAttributes.ts';

    type Props = {
        tileListItems: TileListItem[];
        context: TileListPageContext;
        showTopInfos?: boolean;
        cacheRestored?: boolean;
        onRedirectToPdp?: (item: TileItem) => void;
        onProductItemUpdated?: (item: ProductItem) => void;
        onSliderLoad?: () => void;
        featureIndexOffset: FeatureIndexOffset;
    };

    let {
        tileListItems,
        context,
        showTopInfos = false,
        cacheRestored = true,
        onRedirectToPdp = () => {},
        onProductItemUpdated = () => {},
        onSliderLoad = () => {},
        featureIndexOffset,
    }: Props = $props();
</script>

<TileListSheets />

<ProductGrid
    {tileListItems}
    {context}
    {showTopInfos}
    {cacheRestored}
    {onRedirectToPdp}
    {onProductItemUpdated}
    {onSliderLoad}
    {featureIndexOffset}
/>
